

































import ModalBaseMethod from '@/components/molecules/ModalBaseMethod.vue'
import ModalBase from '@/components/molecules/ModalBase.vue'
import { Component, Mixins, Prop, Ref, Vue } from 'vue-property-decorator'
import ButtonBase from '@/components/atoms/ButtonBase.vue'
import ConversionRoom from '@/components/modules/drillsv3/organisms/ConversionRoom.vue'
import { Message, ResponseQuestions } from '@/types/student'
import IconLoading from '@/components/atoms/v3/IconLoading.vue'
import PropertiesDesign from '@/mixins/v3/PropertiesDesign'

const PER_PAGE = 10

@Component({
  components: {
    ModalBase,
    ButtonBase,
    ConversionRoom,
    IconLoading,
  },
})
export default class ModalChat extends Mixins(ModalBaseMethod, PropertiesDesign) {
  @Ref() input!: HTMLTextAreaElement
  @Ref() conversionRef!: ConversionRoom

  @Prop()
  private curriculumSUnitId!: string | number
  @Prop({ default: '' })
  private userAnswerPath?: string
  @Prop()
  private questionCode!: string

  @Prop()
  isHideInputMessage!: boolean;

  @Prop()
  resultDrillId!: string;
  private isLoadMore = false
  private isLoadData = false
  private error = false
  private isWaitReply = false
  private lastMessage = false
  private totalPage = 2
  private messages: Message[] = []

  private calculatorHeightInput() {
    this.valueInput = this.input.value
    this.input.style.height = 'auto'
    this.input.style.height = this.input.scrollHeight + 'px'
  }

  private valueInput = ''

  public async showModal() {
    this.show()

    // this.messages = await this.sleep()
    this.messages = await this.getConversions()
    if (!this.messages.length) {
      this.lastMessage = true
    }
    this.isLoadData = true
  }

  private resetData() {
    this.messages = []
    this.isLoadData = false
    this.totalPage = 0
    this.lastMessage = false
    this.error = false
  }

  private handleKeyDown(e: KeyboardEvent) {
    if (e.key === 'Enter' && !e.shiftKey) {
      this.sendMessage()
      e.preventDefault()
    }
  }

  private calculatorCurrentPage() {
    const excess = this.messages.length % PER_PAGE
    let currentPage = 1
    if (excess === 0) {
      currentPage = this.messages.length / PER_PAGE
    } else {
      currentPage = Math.floor(this.messages.length / PER_PAGE)
    }
    return { excess, currentPage }
  }

  private async loadMore() {
    const { currentPage, excess } = this.calculatorCurrentPage()
    if (this.lastMessage || !this.totalPage) {
      return
    }
    this.isLoadMore = true
    const res = await this.getConversions(currentPage + 1)

    this.messages.unshift(...res.slice(0, res.length - excess))
    this.isLoadMore = false
    if (excess > 5) {
      this.loadMore()
    }
  }

  private async getConversions(page = 1) {
    try {
      const res = await Vue.prototype.$http.httpWithToken.get(`/v3/question_hints`, {
        params: {
          page: page,
          per_page: PER_PAGE,
          curriculum_s_unit_id: this.curriculumSUnitId,
          question_code: this.questionCode,
          result_drill_id: this.resultDrillId
        },
      })
      if (res.data) {
        this.totalPage = (res.data as ResponseQuestions).totalPage
        if (page == this.totalPage || !this.totalPage) {
          this.lastMessage = true
        }
        return (res.data as ResponseQuestions).histories.reverse()
      }
    } catch {
      this.error = true
      return []
    }
    return []
  }

  getFiveHistoriesLastest() {
    const length = this.messages.length
    const result = []
    for (let i = length - 1; i >= 0; i--) {
      if (!this.messages[i].error && this.messages[i].hintMessage) {
        result.push(this.messages[i])
      }
      if (result.length === 5) {
        break
      }
    }
    return result.reverse()
  }

  private async replyMessage(message: string) {
    const fiveHistoriesLastest = this.getFiveHistoriesLastest()
    try {
      const res = await Vue.prototype.$http.httpWithToken.post(`/v3/question_hints`, {
        curriculum_s_unit_id: this.curriculumSUnitId,
        question_code: this.questionCode,
        user_message: message,
        histories: fiveHistoriesLastest,
        user_answer_path: this.userAnswerPath,
        result_drill_id: this.resultDrillId
      })
      if (res.data) {
        return res.data.histories[0]
      }
    } catch {
      return { hintMessage: 'ネットワークにエラーが発生しました。', userMessage: message, createdAt: new Date().toDateString(), error: true }
    }
    return { hintMessage: 'ネットワークにエラーが発生しました。', userMessage: message, createdAt: new Date().toDateString(), error: true }
  }

  private mountMessage() {
    const message = this.input.value
    this.messages.push({ hintMessage: null, userMessage: message, createdAt: new Date().toDateString() })
    this.input.value = ''
    this.calculatorHeightInput()
    this.scrollBottom()
  }

  private async mountReply(message: string) {
    this.isWaitReply = true
    const reply = (await this.replyMessage(message)) as Message
    if (reply) {
      this.messages.splice(this.messages.length - 1, 1, reply)
    }
    this.isWaitReply = false
  }

  private async sendMessage() {
    if (this.isWaitReply || !this.input.value) {
      return
    }
    const message = this.input.value
    this.mountMessage()
    await this.mountReply(message)
  }

  private scrollBottom() {
    this.conversionRef.scrollBottom()
  }

  private get varibleBot() {
    return {
      '--url-img-bot': `url("${this.characters.default}")`,
      '--url-img-bot-error': `url("${this.characters.error}")`,
    }
  }
}
